import { render } from "./BankCertificate.vue?vue&type=template&id=52b4c46c&scoped=true"
import script from "./BankCertificate.vue?vue&type=script&lang=js"
export * from "./BankCertificate.vue?vue&type=script&lang=js"

import "./BankCertificate.vue?vue&type=style&index=0&id=52b4c46c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b4c46c"]])

export default __exports__